import React from "react";


import { FaFacebook, FaTwitter } from "react-icons/fa";

const Booking = () => {
  return (
    <div>
      <div className="container mx-auto ">
        <div className="flex flex-wrap justify-center items-center">
          <div className="w-full shadow-lg rounded-lg bg-gradient-to-r to-[#f59a61] from-[#f5695d] border-0 my-10 ">
            <div className="relative flex flex-col md:flex-row justify-center items-center min-w-0 break-words w-full mb-3 text-center">
              
              <div className="col-6 flex-auto w-full px-4 lg:px-10 py-10 pt-0">
                <h1 className="text-xl font-bold my-3">Personal Details</h1>
                <form>
                  <div className="w-full">
                  <div className="flex max-sm:flex-wrap ">
                <div className=" w-full mb-3 mx-3">
                    <label
                      className="block uppercase text-left text-gray-700 text-xs font-bold mb-2"
                      htmlFor="full-name"
                    >
                      First Name
                    </label>
                    <input
                      type="text"
                      className="border-0 px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="First Name"
                    />
                  </div>
                  <div className="relative w-full mb-3 mx-3">
                    <label

                      className="block uppercase text-left text-gray-700 text-xs font-bold mb-2"
                      htmlFor="last-name"
                    >
                      Last Name
                    </label>
                    <input
                      type="text"
                      className="border-0 px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="Last Name"
                    />  
                    </div> 
                  </div>
                  <div className="flex max-sm:flex-wrap">
                <div className=" w-full mb-3 mx-3">
                    <label
                      className="block uppercase text-left text-gray-700 text-xs font-bold mb-2"
                      htmlFor="email"
                    >
                      Email
                    </label>
                    <input
                      type="mail"
                      className="border-0 px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="mail@example.com"
                    />
                  </div>
                  <div className="relative w-full mb-3 mx-3">
                    <label

                      className="block uppercase text-left text-gray-700 text-xs font-bold mb-2"
                      htmlFor="last-name"
                    >
                      Phone Number
                    </label>
                    <input
                      type="number"
                      className="border-0 px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="1234567890"
                    />  
                    </div> 
                  </div>
                  <div className="relative mb-3 mx-3">
                    <label

                      className="block uppercase text-left text-gray-700 text-xs font-bold mb-2"
                      htmlFor="street"
                    >
                      Street
                    </label>
                    <input
                      type="text"
                      className="border-0 px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="street-0,"
                    />  
                    </div> 
                    <div className="flex max-sm:flex-wrap">
                <div className=" w-full mb-3 mx-3">
                    <label
                      className="block uppercase text-left text-gray-700 text-xs font-bold mb-2"
                      htmlFor="city"
                    >
                      City
                    </label>
                    <input
                      type="text"
                      className="border-0 px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="City Name"
                    />
                  </div>
                  <div className="relative w-full mb-3 mx-3">
                    <label

                      className="block uppercase text-left text-gray-700 text-xs font-bold mb-2"
                      htmlFor="state"
                    >
                      State
                    </label>
                    <input
                      type="text"
                      className="border-0 px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="State"
                    />  
                    </div> 
                  </div><div className="flex max-sm:flex-wrap">
                <div className=" w-full mb-3 mx-3">
                    <label
                      className="block uppercase text-left text-gray-700 text-xs font-bold mb-2"
                      htmlFor="pin-code"
                    >
                      pin-code
                    </label>
                    <input
                      type="number"
                      className="border-0 px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="123456"
                    />
                  </div>
                  <div className="relative w-full mb-3 mx-3">
                    <label

                      className="block uppercase text-left text-gray-700 text-xs font-bold mb-2"
                      htmlFor="last-name"
                    >
                      Phone Number
                    </label>
                    <input
                      type="number"
                      className="border-0 px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="1234567890"
                    />  
                    </div> 
                  </div>
                    </div>
                  </form>
              </div> 
              <div className="col-6 flex-auto w-full px-4 lg:px-10 py-10 pt-0">
                <h1 className="text-xl font-bold my-3">Booking Details</h1>
                <form>
                  <div className="w-full">
                  <div className="flex max-sm:flex-wrap">
                <div className=" w-full mb-3 mx-3">
                    <label
                      className="block uppercase text-left text-gray-700 text-xs font-bold mb-2"
                      htmlFor="arrival-date"
                    >
                      Arrival Date
                    </label>
                    <input
                      type="date"
                      className="border-0 px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="Arrival Date"
                    />
                  </div>
                  <div className="relative w-full mb-3 mx-3">
                    <label

                      className="block uppercase text-left text-gray-700 text-xs font-bold mb-2"
                      htmlFor="departure-date"
                    >
                      Departure Date
                    </label>
                    <input
                      type="date"
                      className="border-0 px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="Departure Date"
                    />  
                    </div> 
                  </div>
                  <div className="flex max-sm:flex-wrap">
                <div className=" w-full mb-3 mx-3">
                    <label
                      className="block uppercase text-left text-gray-700 text-xs font-bold mb-2"
                      htmlFor="email"
                    >
                      No. of Adults
                    </label>
                    <input
                      type="number"
                      className="border-0 px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="01"
                    />
                  </div>
                  <div className="relative w-full mb-3 mx-3">
                    <label

                      className="block uppercase text-left text-gray-700 text-xs font-bold mb-2"
                      htmlFor="last-name"
                    >
                      Phone Number
                    </label>
                    <input
                      type="number"
                      className="border-0 px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="1234567890"
                    />  
                    </div> 
                  </div>
                    <div className="flex max-sm:flex-wrap">
                <div className=" w-full mb-3 mx-3">
                    <label
                      className="block uppercase text-left text-gray-700 text-xs font-bold mb-2"
                      htmlFor="pin-code"
                    >
                      pin-code
                    </label>
                    <input
                      type="number"
                      className="border-0 px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="123456"
                    />
                  </div>
                  <div className="relative w-full mb-3 mx-3">
                    <label

                      className="block uppercase text-left text-gray-700 text-xs font-bold mb-2"
                      htmlFor="last-name"
                    >
                      Phone Number
                    </label>
                    <input
                      type="number"
                      className="border-0 px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="1234567890"
                    />  
                    </div> 
                    </div>
                    <div className="relative mb-3 mx-3">
                    <label

                      className="block uppercase text-left text-gray-700 text-xs font-bold mb-2"
                      htmlFor="street"
                    >
                      Street
                    </label> 
                    <textarea
                      className="border-0 px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" rows="5"
                      placeholder="Any other request..."
                    />
                    </div>
                    </div>
                  </form>
              </div>  
            </div>
            <div className="flex flex-wrap my-3 relative">
              <div className=" px-4 flex-1 text-end">
                <button
                  className="bg-gray-900 text-white active:bg-gray-700 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                  type="button"
                >
                  Search Now
                </button>
              </div>
            </div>
          
          </div>
          
        </div>
      </div>
    </div> 
  );
};

export default Booking;